<template>
  <div class="container">
    <div class="pp-toolbar pp-toolbar-transparent action-bar">
      <div class="flex-spacer"></div>
      <button class="button" @click="showDefaults = !showDefaults">
        {{showDefaults ? 'Hide default values' : 'Show default values'}}
      </button>
    </div>
    <div class="json">
      <i class="icon icon-copy" title="Copy" @click="copyJsonToClipboard">content_copy</i>
      <pre class="box"><code class="language-js" v-html='jsonConfig'></code></pre>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import { createPlayerConfig } from '../../../utils/player';

export default {
  name: 'PlayerConfigJsonView',
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      showDefaults: false
    };
  },
  computed: {
    jsonConfig () {
      return JSON.stringify(createPlayerConfig(this.config, !this.showDefaults), null, 2);
    }
  },
  updated () {
    Prism.highlightAll();
  },
  mounted () {
    Prism.highlightAll();
  },
  methods: {
    async copyJsonToClipboard () {
      try {
        await navigator.clipboard.writeText(this.jsonConfig);
        Vue.$toast.open({
          message: 'JSON copied to clipboard.',
          duration: 2000,
          position: 'top',
        });
      } catch (err) {
        console.error('Failed to copy to clipboard', err);
      }
    }
  }
};
</script>

<style scoped>
  .container {
    position: relative;
  }

  .json {
    position: relative;
  }

  .box {
    overflow-x: scroll;
    margin: 0;
  }

  .icon-copy {
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
    color: #d0d0d0;
  }
</style>
